module.exports = __webpack_public_path__ + "public/img/exportAtt.434f9838.png";